import {maybe} from '@freckle/maybe'
import type {GenericAssignmentSessionAttrsT} from '@freckle/educator-entities/ts/common/models/generic-assignment-session'
import type {RlDomainT} from '@freckle/educator-entities/ts/common/models/rl-domain'
import type {RlStandardWithDomainT} from '@freckle/educator-entities/ts/common/models/rl-standard'
import type {RlStandardSetT} from '@freckle/educator-entities/ts/common/models/rl-standard-set'
import * as MathAssessmentTopic from '@freckle/educator-entities/ts/math/assessment/types/assessment-topic'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import {formattedName} from '@freckle/educator-entities/ts/users/models/teacher'
import {H2} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {table} from '../table.module.scss'

type Props = {
  teacher: BaseTeacherAttrs
  assessmentSessions: Array<GenericAssignmentSessionAttrsT>
  mathStandardSet: RlStandardSetT
  domains: Array<RlDomainT>
  standards: Array<RlStandardWithDomainT>
}

export default function AssessmentTeacherReport(props: Props) {
  const {t} = useSafeTranslation()
  const {teacher, mathStandardSet, domains, standards, assessmentSessions} = props

  const mFirstMetadata = assessmentSessions.flatMap(session =>
    session.metadata.tag === 'math_assessments' ? [session.metadata] : []
  )[0]

  return (
    <>
      <H2>{t('ASSESSMENT_REPORT_ASSESSMENT_TEACHER_TITLE')}</H2>

      <table className={table}>
        <thead>
          <tr>
            <th>{t('ASSESSMENT_REPORT_ASSESSMENT_TEACHER_COLUMN_TITLE')}</th>
            <th>{t('ASSESSMENT_REPORT_ASSESSMENT_DATE_COLUMN_TITLE')}</th>
            <th>{t('ASSESSMENT_REPORT_ASSESSMENT_GRADE_COLUMN_TITLE')}</th>
            <th>{t('ASSESSMENT_REPORT_ASSESSMENT_DOMAINS_COLUMN_TITLE')}</th>
            <th>{t('ASSESSMENT_REPORT_ASSESSMENT_NUM_OF_STUDENTS_COLUMN_TITLE')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{formattedName(teacher)}</td>
            <td>
              {maybe(
                () => '',
                ({createdAt}) => createdAt.format('ll'),
                assessmentSessions[0]
              )}
            </td>
            <td>
              {maybe(
                () => '',
                ({contents: {topic}}) => t('DISPLAY_GRADE_ORDINAL', {grade: topic.schoolGrade}),
                mFirstMetadata
              )}
            </td>
            <td>
              {maybe(
                () => '',
                ({contents: {topic}}) =>
                  MathAssessmentTopic.format(topic, mathStandardSet, domains, standards, t),
                mFirstMetadata
              )}
            </td>
            <td>{assessmentSessions.length}</td>
          </tr>
        </tbody>
      </table>
    </>
  )
}
